import { useContext } from "react"
import { useSubUsersENT } from "../../../../../../hooks/fetchers/useSubUsersENT/useSubUsersENT"
import Loading from "../../../../../commons/Loading/Loading"
import Button from "../../../../../designSystem/Button/Button"
import { ButtonColor } from "../../../../../designSystem/Button/Button.types"
import { ProfileSubUsersENTContext } from "../ProfileSubUsersENT.context"
import { ReactComponent as SearchIcon } from '../../../../../../assets/vectors/search.svg'
import SearchInput from "../../../../../commons/SearchInput/SearchInput"
import { getSubUserRightLabel } from "../../../../../../utils/helpers/user/getSubUserRightLabel"

export default () => {

  const { data, isLoading } = useSubUsersENT()

  // const [isUpdateModalOpen, setUpdateModalOpen] = useState(false)
  // const [selectedSubUser, setSelectedSubUser] = useState<SubUser>()

  const { setSubUserToUpdate, setUpdateModalOpen, setAddModalOpen } = useContext(ProfileSubUsersENTContext)

  if (isLoading) return <Loading />

  return (
    <div className="dashboard-commerciaux">
      <div className="dashboard-commerciaux__header">
        <SearchInput
          placeholder="Chercher un sous-utilisateur..."
          startIcon={SearchIcon}
          // onChange={onChangeSearchText}
          // handleSelectedSuggestion={(suggestion) => console.log(suggestion)}
          disabled
        />
        <Button
          color={ButtonColor.Secondary}
          onClick={() => setAddModalOpen(true)}
        >
          Créer un sous-utilisateur
        </Button>
      </div>
    <table className="dashboard__table dashboard-commerciaux__table" style={{ flex: 0 }}>
      <thead>
        <tr>
          <th>Prénom</th>
          <th>Nom</th>
          <th>Adresse email</th>
          <th>Droits</th>
        </tr>
      </thead>
      <tbody>
        {data?.map((subUser, index) => {
          return (
            <tr key={index}>
              <td>{subUser.firstName}</td>
              <td>{subUser.lastName}</td>
              <td>{subUser.email}</td>
              <td>
                {subUser.rights.split(',').map(n => getSubUserRightLabel(parseInt(n)))}
              </td>
              <td>
                <Button
                  color={ButtonColor.Secondary}
                  onClick={() => {
                    setUpdateModalOpen(true)
                    setSubUserToUpdate(subUser)
                  }}
                >
                  Modifier
                </Button>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
    </div>
  )
}